export const getNumberFormatter = (
  value?: number | null,
  locale?: string,
  options?: Intl.NumberFormatOptions
) => {
  if (!value) return undefined;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: options?.minimumFractionDigits ?? 2,
    maximumFractionDigits: options?.maximumFractionDigits ?? 2,
  }).format(value);
};
